import { SEARCHES_PER_PAGE } from "features/favourites/constants";
import { PaginationParams } from "features/favourites/provider/favouritesProvider";
import { useQuery, useQueryClient } from "react-query";
import { SavedSearchesClient } from "services/motorpoint/user-context-api";
import type { UserContext, UserContextId } from "services/motorpoint/user-context-api/types";

export type ShortlistedVehicleType = {
    id: number;
    timestamp: number;
};

const savedSearchesClient = new SavedSearchesClient({
    useEnv: true,
});

export const QUERY_KEY = "favourites:searches";

const calculatePaginationParams = (page: number): { offset: number; limit: number } => ({
    offset: (page > 0 ? page - 1 : 0) * SEARCHES_PER_PAGE,
    limit: SEARCHES_PER_PAGE,
});

const useSavedSearches = ({ userContextId, page = 0, order }: UserContextId & PaginationParams) => {
    const paginationParams = calculatePaginationParams(page);
    const queryClient = useQueryClient();
    const getByUserContextId = savedSearchesClient.getByUserContextId.bind(savedSearchesClient);

    return useQuery({
        queryKey: [QUERY_KEY, page, order],
        queryFn: () => getByUserContextId({ userContextId, ...paginationParams, order }),
        retry: 3,
        retryDelay: (attemptIndex, error) => {
            return Math.pow(2, attemptIndex) * 200;
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        enabled: !!userContextId,
        onSuccess: (data) => {
            //update userContextMeta to update the counter in the header

            queryClient.setQueryData("userContext", (oldData: UserContext | undefined) => {
                return Object.assign({}, oldData, {
                    savedDataMeta: {
                        ...oldData?.savedDataMeta,
                        savedSearchesCount: data?.pagination?.total ?? 0,
                    },
                });
            });
        },
    });
};

export default useSavedSearches;
